import request from '@/utils/zsm-requets'
let bank = '/zsm/api/bank/'
/**
 *   新增银行卡
 */
export function createBank(params) {
  return request({
    url: bank + 'create',
    method: 'post',
    params
  })
}
/**
 *   删除银行卡
 */
export function deleteBank(id) {
  return request({
    url: bank + 'delete',
    method: 'post',
    params:{id}
  })
}
/**
 *   银行卡列表
 */
export function listDataBank(params) {
  return request({
    url: bank + 'listData',
    method: 'post',
    params
  })
}
/**
 *  修改银行卡
 */
export function updateBank(params) {
  return request({
    url: bank + 'update',
    method: 'post',
    params
  })
}
/**
 *  查看银行卡
 */
export function getBank(params) {
  return request({
    url: bank + 'get',
    method: 'post',
    params
  })
}
